export default __webpack_public_path__ + "static/media/camera.a1dc47d9.png";